import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const BlankPage = lazy(() => import('../../container/pages/BlankPage'));
const Dashboard = lazy(() => import('../../container/pages/Dashboard'));
const Settings = lazy(() => import('../../container/profile/settings/Settings'));
const DeviceLogs = lazy(() => import('../../container/pages/device-logs/DeviceLogs'));
const ActionLogs = lazy(() => import('../../container/pages/action-logs/ActionLogs'));
const DeviceQueueLogs = lazy(() => import('../../container/pages/device-queue-logs/DeviceQueueLogs'));
const LicenceActivities = lazy(() => import('../../container/pages/licence-activities/LicenceActivities'));
const Invites = lazy(() => import('../../container/pages/invites/Invites'));
const MailSettings = lazy(() => import('../../container/pages/settings/MailSettings'));
function PagesRoute() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="starter" element={<BlankPage />} />
      <Route path="profile/*" element={<Settings />} />
      <Route path="settings/mail" element={<MailSettings />} />
      <Route path="device-logs" element={<DeviceLogs />} />
      <Route path="admin/action-logs" element={<ActionLogs />} />
      <Route path="admin/device-queue-logs" element={<DeviceQueueLogs />} />
      <Route path="admin/licence-activities" element={<LicenceActivities />} />
      <Route path="admin/invites" element={<Invites />} />
    </Routes>
  );
}

export default PagesRoute;
